enum CampaignAnalyticsToolName {
  GetCampaignAnalytics = 'get-campaign-analytics',
  GetCampaignAnalyticsData = 'get-campaign-analytics-data',
  DeleteWidget = 'delete-widget',
  UpdateWidget = 'update-widget',
  DeleteDashboard = 'delete-dashboard',
  RenameDashboard = 'rename-dashboard',
  SupportedMetrics = 'supported-metrics',
  SupportedDimensions = 'supported-dimensions',
  SupportedFilterValues = 'supported-filter-values',
  GetCampaignTopPerforming = 'get-campaign-top-performing',
  CreateDashboard = 'create-dashboard',
  CreateWidget = 'create-widget',
  CheckWidgetExists = 'check-widget-exists',
  HighlightWidget = 'highlight-widget',
  CampaignAnalyticsTableData = 'campaign-analytics-table-data',
  OpenDashboard = 'open-dashboard',
  GetCampaignWorstPerforming = 'get-campaign-worst-performing',
  PersistInlineWidgetToDashboard = 'persist-inline-widget-to-dashboard',

  NavigateToCampaignInsights = 'navigate-to-campaign-insights',
  AnalyzeNodeFallback = 'analyze-node-fallback',
}

export {CampaignAnalyticsToolName};
